import { marked } from "marked";
import "./mdviewer.css";

const renderer = new marked.Renderer();

const DATA_PREFIX = "data://";

class MarkdownViewerElement extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const src = this.getAttribute("src");
        if (!src) {
            throw Error("missing src");
        }
        const isData = src.startsWith(DATA_PREFIX);

        if (isData) {
            const raw = src.slice(DATA_PREFIX.length, -1);
            marked
                .parse(raw, {
                    async: true,
                    renderer,
                    gfm: true,
                    breaks: true,
                })
                .then((parsed) => {
                    this.innerHTML = parsed;
                })
                .catch(() => {
                    this.innerHTML = `<p class="error">failed to load markdown</p>`;
                });
        } else {
            fetch(src)
                .then((res) => res.text())
                .then((md) =>
                    marked.parse(md, {
                        async: true,
                        renderer,
                        gfm: true,
                        breaks: true,
                    }),
                )
                .then((parsed) => {
                    this.innerHTML = parsed;
                })
                .catch(() => {
                    this.innerHTML = `<p class="error">failed to load markdown</p>`;
                });
        }
    }
}

customElements.define("bd-mdviewer", MarkdownViewerElement);
